export function isKeyboardClickKey(key: string) {
    return key === "Space" || key === "Enter";
}
